const React = require("react");
const T = React.PropTypes;

const TextStateTicker = React.createClass({
    propTypes: {
        TextVals: T.arrayOf(T.string).isRequired,
        TickIntervalMS: T.number,
        style: T.object
    },
    getDefaultProps() {
        return {
            TickIntervalMS: 500
        };
    },
    componentWillMount() {
        this.setState({
            TickerHandle: setInterval(this.Tick, this.props.TickIntervalMS)
        });
    },
    getInitialState() {
        return {
            TextValIndex: 0,
            TickerHandle: null
        };
    },
    render() {
        const val = this.GetVal();

        const style = Object.assign({}, {
            display: "inline-block"
        }, this.props.style);

        return (<span style={style }>{val}</span>);
    },
    componentWillUnmount() {
        clearInterval(this.state.TickerHandle);
    },
    GetVal() {
        return this.props.TextVals[this.state.TextValIndex];
    },
    Tick() {
        const newIndex = this.state.TextValIndex === this.props.TextVals.length
            ? 0
            : this.state.TextValIndex + 1;

        this.setState({
            TextValIndex: newIndex
        });
    }
});

module.exports = TextStateTicker;


// WEBPACK FOOTER //
// ./src/components/TextStateTicker/TextStateTicker.jsx